import React from 'react';
import {connect} from 'react-redux';
import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchAffordability,
  deleteAffordabilityDocument
} from 'ducks/bookings';
import {MODALS as BASE_MODALS, closeModal} from 'ducks/modals';

import {TenantInfo, EmploymentsTable, ProofOfIncomeTable} from './components';

import './styles.css';

class AffordabilityDetailModal extends React.Component<any> {
  componentDidMount() {
    this.fetchAffordability();
  }

  fetchAffordabilityExtraActions = () => {
    return this.props.storeDataExtraActions(data => ({
      affordability: data
    }));
  };

  fetchAffordability = () => {
    const {data: {affordabilityId, bookingId}} = this.props;

    this.props.fetchAffordability(
      {
        bookingId,
        affordabilityId
      },
      this.fetchAffordabilityExtraActions()
    );
  };

  openConfirmDeletionModal = ({confirmAction, documentName}) => {
    this.props.openConfirmationModal({
      heading: 'Delete document',
      question: `Are you sure you want to permanently delete ${documentName}?`,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Delete',
      confirmAction: confirmAction
    });
  };

  deleteDocument = ({documentId, documentName}) => {
    const {data: {affordabilityId, bookingId}} = this.props;

    const fetchAffordabilityExtraActions = [
      ...this.fetchAffordabilityExtraActions(),
      () => closeModal(BASE_MODALS.CONFIRM)
    ];
    const deleteDocumentExtraActions = [
      () =>
        fetchAffordability(
          {
            bookingId,
            affordabilityId
          },
          fetchAffordabilityExtraActions
        )
    ];

    const confirmAction = () =>
      this.props.deleteAffordabilityDocument(
        {documentId},
        deleteDocumentExtraActions
      );

    this.openConfirmDeletionModal({confirmAction, documentName});
  };

  render() {
    const {
      data: {affordability, affordabilityId},
      openAffordabilityDocumentUploadModal,
      openAddEmploymentModal
    } = this.props;

    return (
      <div>
        {affordability && (
          <Modal
            show={true}
            onClose={this.props.closeModal}
            className="AffordabilityDetailModal">
            <Modal.Header>
              <h3 className="header">Employment</h3>
            </Modal.Header>
            <Modal.Body>
              <TenantInfo
                agreementUser={affordability.agreementUser}
                affordabilityId={affordabilityId}
                openAffordabilityDocumentUploadModal={
                  openAffordabilityDocumentUploadModal
                }
                openAddEmploymentModal={openAddEmploymentModal}
              />
              <EmploymentsTable
                employments={affordability.agreementUser.employmentHistory}
              />
              <ProofOfIncomeTable
                documents={affordability.documents}
                deleteDocument={this.deleteDocument}
              />
            </Modal.Body>
          </Modal>
        )}
        {!affordability && null}
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchAffordability,
  deleteAffordabilityDocument
};

export default connect(null, mapDispatchToProps)(withModal(
  MODALS.AFFORDABILITY_DETAIL
)(AffordabilityDetailModal) as React.ComponentType<any>);
